import styled from 'styled-components';
import { BdsIcon, BdsInput } from 'blip-ds/dist/blip-ds-react';

export const SearchInput = styled(BdsInput)`
  width: 18.75rem;
`;

export const MoreOptionsButton = styled(BdsIcon)`
  cursor: pointer;
`;
